import React, { useEffect, useState, useCallback, useRef } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu"; 
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon"; 
import { Link } from "react-router-dom";

const GNBPURE04002S = () => {
  const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
  const [notiList, srchList] = useState([]); // 프로젝트 리스트
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
  const [pagination, setPagination] = useState({ pageNo: 1, prevYn: "N", nextYn: "N", startPage: 1, endPage: 1 });

  const goSearch = (pageNo = 1) => {
    const actionForm = {
      txGbnCd: "srchList",
      pageNo: pageNo,
    };
      
    doAction("COM0001SC", actionForm, (resData) => {
      if (resData.APP_HEADER.respCd === "N00001") {
        srchList(resData.LIST || []);
        setPagination({
          pageNo: resData.pageNo,
          prevYn: resData.prevYn,
          nextYn: resData.nextYn,
          startPage: resData.startPage,
          endPage: resData.endPage,
        });
      }
    });
};


const memoizedGoSearch = useCallback(goSearch, []);
  // ✅ 최초 조회
  useEffect(() => {
    goSearch();
  }, [memoizedGoSearch]);
  
  
  return (
    <CommonLayout>
      <CommonMenu/>
      
      <div id="contents" className="container">
        <div className="sub-title bg-type05">
          <h2>고객지원</h2>	
        </div>
        <div className="location_wrap">
          <ul className="depth1"  onClick={() => setIsDepthOpen(!isDepthOpen)}>
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>NOTICE<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE04001S">제휴문의</Link></li>
                <li><Link to="/GNBPURE04002S">NOTICE</Link></li>
                <li><Link to="/GNBPURE04003S">Contact Us</Link></li>
              </ul>
            </li>
          </ul>
        </div>

        <section id="notice" className="notice-section">
          <div className="noticontainer">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="section-heading">NOTICE</h2>
                <hr className="notiprimary" />
              </div>

              <div className="notice-grid">

                {notiList.map((column, columnIndex) => (
                  <div key={columnIndex} className="notice-card" style={{ background: columnIndex % 2 === 0 ? "#F4F4F4" : "#FAFAFA" }}>
                     <h3>{column.pbanc_ttl}</h3>
                          <span>
                            {column.pbanc_cntn}
                            
                          </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 페이지네이션 */}
        <ul className="boardPage">
          {pagination.prevYn === "Y" && (
            <li>
              <button onClick={() => goSearch(pagination.pageNo - 1)} title="이전페이지">
                ⬅ 이전
              </button>
            </li>
          )}

          {Array.from({ length: pagination.endPage - pagination.startPage + 1 }, (_, i) => pagination.startPage + i).map((num) => (
            <li key={num} className={pagination.pageNo === num ? "on" : ""}>
              <button onClick={() => goSearch(num)}>{num}</button>
            </li>
          ))}

          {pagination.nextYn === "Y" && (
            <li>
              <button onClick={() => goSearch(pagination.pageNo + 1)} title="다음페이지">
                다음 ➡
              </button>
            </li>
          )}
        </ul>
        
      </div>

      
      <CommonFooter/>
    </CommonLayout>
  );
};

export default GNBPURE04002S;